import { action_options, app_modules } from "helpers/apps_modules_list";
import OrganisationsList from "pages/UserManagement/Organisations/List/OrganisationsList";
import OrganisationsForm from "pages/UserManagement/Organisations/Form/OrganisationsForm";
import DepartmentList from "pages/UserManagement/Department/List/DepartmentList";
import DepartmentForm from "pages/UserManagement/Department/Form/DepartmentForm";
import TeamList from "pages/UserManagement/Team/List/TeamList";
import TeamstForm from "pages/UserManagement/Team/Form/TeamsForms";
import UserList from "pages/UserManagement/User/List/UserList";
import UserForm from "pages/UserManagement/User/Form/UserForm";
import ModuleList from "pages/UserManagement/Module/List/Module";
import AddModuleForm from "pages/UserManagement/Module/Form/ModuleForm";
import UserTypeList from "pages/UserManagement/UserType/List/UserTypeList";
import UserTypeForm from "pages/UserManagement/UserType/Form/UserTypeForm";
import AddUserTypeModal from "pages/UserType/AddUserTypeModal";
import UsersTypeList from "pages/UserType/UserTypeList";

const UserManagementRoutes: any = [
  //for creating new  organisation
  {
    path: "/organisations-list",
    name: "OrganisationsList",
    component: <OrganisationsList />,
  },
  {
    path: "/organisation-form",
    name: "Organisations",
    component: <OrganisationsForm />,
  },
  {
    path: "/edit-organisation/:id",
    name: "EditOrganisation",
    component: <OrganisationsForm />,
  },

  //for creating department and listing departments
  {
    path: "/department-list",
    name: "DepartmentList",
    component: <DepartmentList />,
  },
  { path: "/department-form", name: "UserForm", component: <DepartmentForm /> },
  {
    path: "/department-form/:id",
    name: "Department",
    component: <DepartmentForm />,
  },

  //for creating team and listing teams
  { path: "/team-list", name: "TeamList", component: <TeamList /> },
  { path: "/team-forms", name: "UserForm", component: <TeamstForm /> },
  { path: "/team-forms/:id", name: "UserForm", component: <TeamstForm /> },

  // User Type Routes
  {path: "/userType-list", name: "UserTypeList", component: <UserTypeList/> },
  {path: "/userType-form", name: "UserTypeForm", component: <UserTypeForm/> },
  {path: "/userType/:id", name: "UserTypeForm", component: <UserTypeForm/> },
  {
    path: "/user-type",
    name: "userTypes",
    component: <UsersTypeList />,
    permissions: {
      app_name: app_modules.user_management.app_name,
      module_name: app_modules.user_management.modules.userType,
      action: action_options?.view,
    },
  },
  {
    path: "/add-usertypes",
    name: "userTypesModules",
    component: <AddUserTypeModal />,
    permissions: {
      app_name: app_modules.user_management.app_name,
      module_name: app_modules.user_management.modules.userType,
      action: action_options?.create,
    },
  },
  {
    path: "/add-usertypes/:id",
    name: "userTypesModules",
    component: <AddUserTypeModal />,
    permissions: {
      app_name: app_modules.user_management.app_name,
      module_name: app_modules.user_management.modules.userType,
      action: action_options?.update,
    },
  },

  //for creating new user and listing users
  { path: "/user-list", name: "UserList", component: <UserList /> },
  { path: "/user-form", name: "UserForm", component: <UserForm /> },
  {
    path: "/user-form/:id",
    name: "UserForm",
    component: <UserForm />,
  },
  {
    path: "/user-form/:id/permissions",
    name: "UserPermissions",
    component: <UserForm page="permissions" />,
  },

  //routes for the materail ui components
  { path: "/master/module-list", name: "ModuleList", component: <ModuleList /> },
  { path: "/master/module-form", name: "ModuleForm", component: <AddModuleForm /> },
  {
    path: "/master/edit-module-form/:id",
    name: "ModuleForm",
    component: <AddModuleForm />,
  },
];

export default UserManagementRoutes;

